export function buildMemorialShareUrl(graveId: string): string {
  const url = new URL(window.location.origin);
  url.pathname = `/share/memorial/${encodeURIComponent(graveId)}`;
  url.search = "";
  url.hash = "";
  return url.toString();
}

/** Facebook web share dialog (opens facebook.com in a new window). */
export function buildFacebookShareUrl(pageUrl: string, quote?: string): string {
  const params = new URLSearchParams({ u: pageUrl });
  if (quote) params.set("quote", quote);
  return `https://www.facebook.com/sharer/sharer.php?${params.toString()}`;
}
